import {AmountControl, BaseControl, DatepickerControl, Helper, SelectControl} from 'appShared/classes';
import {ComponentTypesEnum} from 'appShared/enums';
import {DialogButtonTypesEnum, DialogConfigInterface} from 'appShared/components';
import {Validators} from '@angular/forms';
import * as moment from 'moment';
import {environment} from 'appEnv/environment';
import {ClientStatusesEnum, ClientUserStatusesEnum, UserRelationTypesEnum} from '@spa/api';

export const CreateBundleSubscriptionActivationDateSelector = 'CreateBundleSubscriptionActivationDate';
export const CreateBundleSubscriptionPriceSelector = 'CreateBundleSubscriptionPrice';
export const CreateBundleSubscriptionCurrencySelector = 'CreateBundleSubscriptionCurrency';



export const UpdteBundleSubscriptionActivationDateSelector = 'UpdteBundleSubscriptionActivationDate';
export const UpdteBundleSubscriptionDeActivateDateSelector = 'UpdteBundleSubscriptionDeActivateDate';
export const UpdteBundleSubscriptionPriceSelector = 'UpdteBundleSubscriptionPrice';
export const UpdteBundleSubscriptionMarkupSelector = 'UpdteBundleSubscriptionMarkup';
export const UpdteBundleSubscriptionCurrencySelector = 'UpdteBundleSubscriptionCurrency';


export const SUBSCRIPTION_SCHEDULED_DATE_FORMAT = 'YYYY-MM-DD';
export const SUBSCRIPTION_MAX_DATE = 10;

export const isCientActive = (userRelationType: UserRelationTypesEnum, status: number): boolean => {
    if (userRelationType === UserRelationTypesEnum.Individual) {
        return status === ClientStatusesEnum.Active;
    }

    return status === ClientUserStatusesEnum.Active;
};

export const isCientBlocked = (userRelationType: UserRelationTypesEnum, status: number): boolean => {
    if (userRelationType === UserRelationTypesEnum.Individual) {
        return status === ClientStatusesEnum.Blocked;
    }

    return status === ClientUserStatusesEnum.Blocked;
};

export const isCientUserActiveOrBlocked = (
    userRelationType: UserRelationTypesEnum,
    status: number
): boolean => isCientActive(userRelationType, status) || isCientBlocked(userRelationType, status);


export const CreateBundleSubscriptionDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm,
                hidden: true,
                customText: 'Add Bundle'
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false,
        disabledCloseBtn: true
    };
};

export const CreateBundleSubscriptionControls = (): BaseControl<string | number | boolean>[] => {
    return [
        new DatepickerControl({
            name: CreateBundleSubscriptionActivationDateSelector,
            value: Helper.formatDateByValueOrNow(null, environment.dateFormatLocalDate, true),
            placeholder: 'Schedule Activation',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Datepicker,
            maxDate: moment().add(SUBSCRIPTION_MAX_DATE, 'years').format(SUBSCRIPTION_SCHEDULED_DATE_FORMAT),
            minDate: moment(new Date()).format(SUBSCRIPTION_SCHEDULED_DATE_FORMAT),
            floatingLabelNever: false
        }),
        new AmountControl({
            name: CreateBundleSubscriptionPriceSelector,
            value: null,
            placeholder: 'Price',
            validators: [],
            componentType: ComponentTypesEnum.AmountInput,
            currency: null
        }),
        new SelectControl({
            name: CreateBundleSubscriptionCurrencySelector,
            value: null,
            placeholder: 'Currency',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: [],
            multiple: false,
        }),
    ];
};

export const EditBundleSubscriptionDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm,
                customText: 'Update'
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false,
        disabledCloseBtn: true
    };
};

function getMinDateBy(isActiveBundle: boolean) {

    if (!isActiveBundle) {
        return moment(new Date()).add(-1, 'days').format(SUBSCRIPTION_SCHEDULED_DATE_FORMAT);
    }

    return moment(new Date()).format(SUBSCRIPTION_SCHEDULED_DATE_FORMAT);
}

export const EditBundleSubscriptionControls = (isActiveBundle: boolean): BaseControl<string | number | boolean>[] => {
    return [
        new AmountControl({
            name: UpdteBundleSubscriptionPriceSelector,
            value: null,
            placeholder: 'Price',
            validators: [],
            componentType: ComponentTypesEnum.AmountInput,
            currency: null,
            isInitialFormattingActive: true,
            floatingLabelNever: false,
        }),
        new AmountControl({
            name: UpdteBundleSubscriptionMarkupSelector,
            value: null,
            placeholder: 'Set Mark-up',
            validators: [],
            componentType: ComponentTypesEnum.AmountInput,
            currency: null,
            isInitialFormattingActive: true,
            floatingLabelNever: false,
        }),
        new DatepickerControl({
            name: UpdteBundleSubscriptionActivationDateSelector,
            value: null,
            placeholder: '(edit) Activation Date',
            validators: [],
            componentType: ComponentTypesEnum.Datepicker,
            maxDate: moment().add(SUBSCRIPTION_MAX_DATE, 'years').format(SUBSCRIPTION_SCHEDULED_DATE_FORMAT),
            minDate: moment(new Date()).format(SUBSCRIPTION_SCHEDULED_DATE_FORMAT),
            floatingLabelNever: false,
        }),
        new DatepickerControl({
            name: UpdteBundleSubscriptionDeActivateDateSelector,
            value: null,
            startDateAt: moment().endOf('months').toDate(),
            placeholder: '(deactivate) Schedule Deactivation',
            validators: [],
            componentType: ComponentTypesEnum.Datepicker,
            maxDate: moment().add(SUBSCRIPTION_MAX_DATE, 'years').format(SUBSCRIPTION_SCHEDULED_DATE_FORMAT),
            minDate: getMinDateBy(isActiveBundle),
            floatingLabelNever: false,
        }),
        new SelectControl({
            name: UpdteBundleSubscriptionCurrencySelector,
            value: null,
            placeholder: 'Currency',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: [],
            multiple: false,
        }),
    ];
};
